import { Patient } from 'src/app/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import {
  PatientBillingSummaryReqCommand,
  PatientBillingSummaryResp,
  PatientListReqCommand,
  PatientListResp,
  Response,
  UpdatePatientDefaultPaymentMethodReqCommand,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PatientService {
  private api: string = CONTROLLERS.TENANTS.PATIENT;
  constructor(private apiService: ApiService) { }

  getTodayPatientList(
    patientListReqCommand: PatientListReqCommand
  ): Observable<Response<PatientListResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.GET_TODAYS_PATIENT_LIST}`,
      patientListReqCommand
    );
  }

  getAllPatientList(
    patientListReqCommand: PatientListReqCommand
  ): Observable<Response<PatientListResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.GET_ALL_PATIENT_LIST}`,
      patientListReqCommand
    );
  }

  getPatientSummary(
    patientBillingSummaryReqCommand: PatientBillingSummaryReqCommand
  ): Observable<Response<PatientBillingSummaryResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.GET_PATIENT_SUMMARY}`,
      patientBillingSummaryReqCommand
    );
  }

  exportToExcelDos(patientId: number, practiceId: number,  startDate?: any,endDate?: any,paymentStatus?: number) : Observable<Blob>{
    return this.apiService.postBlob(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.EXPORT_TO_EXCEL_DOS}`,
      { patientId, practiceId, startDate, endDate, paymentStatus }
    );
  }

  getPatientBillingSummary(
    patientBillingSummaryReqCommand: PatientBillingSummaryReqCommand
  ): Observable<Response<PatientBillingSummaryResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.GET_PATIENT_BILLING_SUMMARY}`,
      patientBillingSummaryReqCommand
    );
  }

  getPatientDropdown(
    practiceId: number,
    searchTerm: string,
    isAmountGreaterZero: boolean
  ) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.PATIENT_DROPDOWN}`,
      {
        practiceId,
        searchTerm,
        isAmountGreaterZero,
      }
    );
  }

  sendDeadLetterMessages(
    customerId: number,
    transactionId: number,
    messageId: string,
    isProceedDuplicateTransaction: boolean
  ) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.SEND_DEAD_LETTER_MESSAGES}`,
      {
        customerId,
        transactionId,
        messageId,
        isProceedDuplicateTransaction
      }
    );
  }

  syncNow(practiceId: number, patientIds: number[] = []) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.SYNC_NOW}`,
      {
        practiceId,
        patientIds,
      }
    );
  }

  // updateDefualtPaymentMethodOfPatient(patientId: number, defaultPaymentMethod: number, practiceId: number, customerId: number) {
  updateDefualtPaymentMethodOfPatient(reqCommand: UpdatePatientDefaultPaymentMethodReqCommand) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PATIENT.UPDATE_DEFAULT_PAYMENT_METHOD}`,reqCommand);
  }
}
